import {Project} from "../models/basic/project";
import {URLS} from "./app-urls";
import {AbstractService, Filters} from "./abstract-service";

export type ProjectFilter = Filters & {
    name: string;
    active: string;
    client: string;
    po_id?: string;
};

export class ProjectService extends AbstractService<Project> {

    constructor() {
        super(URLS.PROJECT);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.active) {
            if(processedFilter.active === "0") {
                delete processedFilter.active;
            } else {
                processedFilter.active = processedFilter.active === "active";
            }
        }

        return processedFilter;
    }

}
